import React, { useContext, useState } from 'react';
import {
  faGlobeEurope,
  faMoon,
  faSun,
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';
import useLocalStorage from 'use-local-storage';
import { useIntl } from 'react-intl';
import LanguageContext from '../../Context/Language';
import THEME from '../../types/theme.enum';
import { languages } from '../../types/language.enum';
import style from './Options.module.css';

function Options() {
  const intl = useIntl();

  const [theme, setTheme] = useLocalStorage<string | null>('theme', null);
  const { language, changeLanguage } = useContext(LanguageContext);
  const [isLanguageToolTipMounted, setLanguageToolTipMounted] = useState<boolean>(true);
  const [isThemeToolTipMounted, setThemeToolTipMounted] = useState<boolean>(true);
  const otherLanguage = languages.find((l) => l !== language) || 'fr-FR';

  function changeTheme() {
    if (theme === THEME.LIGHT) {
      document.getElementsByTagName('body')[0].classList.remove(THEME.LIGHT);
      setTheme(THEME.DARK);
    } else {
      document.getElementsByTagName('body')[0].classList.add(THEME.LIGHT);
      setTheme(THEME.LIGHT);
    }
  }

  function translate() {
    changeLanguage(otherLanguage); // Oneliner to return other language than the current one
    setLanguageToolTipMounted(false);
  }

  return (
    <>
      <div
        data-testid="switchLanguage"
        className={style.switchLanguage}
        onClick={translate}
        data-tip={intl.formatMessage(
          {
            id: 'language.change-message',
          },
          { language: otherLanguage },
        )}
        data-for="language-tooltip"
        onMouseEnter={() => setLanguageToolTipMounted(true)}
        onMouseLeave={() => {
          setLanguageToolTipMounted(false);
          setTimeout(() => setLanguageToolTipMounted(true), 50);
        }}
      >
        <FontAwesomeIcon icon={faGlobeEurope} />
        {' '}
        <span>{language?.split('-')[1]}</span>
      </div>
      <div
        data-testid="switchTheme"
        className={style.switchTheme}
        onClick={changeTheme}
        data-tip={intl.formatMessage({
          id: 'theme.change-message',
        })}
        data-for="theme-tooltip"
        onMouseEnter={() => setThemeToolTipMounted(true)}
        onMouseLeave={() => {
          setThemeToolTipMounted(false);
          setTimeout(() => setThemeToolTipMounted(true), 50);
        }}
      >
        <FontAwesomeIcon icon={theme === THEME.LIGHT ? faMoon : faSun} />
      </div>
      {isLanguageToolTipMounted && (
        <ReactTooltip id="language-tooltip" place="left" html />
      )}
      {isThemeToolTipMounted && (
        <ReactTooltip id="theme-tooltip" place="left" />
      )}
    </>
  );
}

export default Options;
